import styled from "styles/styled_components";

const StyledExpanderWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const StyledExpanderContent = styled.ul`
  background-color: ${props => props.theme.colors.brandWhite};
  border-radius: ${props => props.theme.spacing.xsmall};
  box-shadow: ${props => props.theme.shadows.large};
  position: absolute;
  right: 0;
  top: 100%;
  z-index: ${props => props.theme.layering.dropdown};

  & > hr {
    border: ${props => props.theme.lightBorder};
  }
`;

export { StyledExpanderWrapper, StyledExpanderContent };
